<div class="drawer-container">
  <div class="drawer-header">
    @if (!config()?.isCustomHeader) {
      <div class="drawer-header-title">
        <span>{{ config()?.title }}</span>
        @if (config()?.isBeta) {
          <span><app-beta></app-beta></span>
        }
      </div>
      <div class="drawer-header-close" (click)="close()">
        <i class="drawer-header-close-icon" aria-label="close" title="close" tabindex="0" (keyup.enter)="close()"></i>
      </div>
    }
  </div>
  <div class="drawer-content" [class.default-padding]="config()?.isDrawerContentDefaultPadding">
    <div class="component-outlet-wrapper" [ngClass]="{ 'component-outlet-wrapper-full-height': config()?.setContentToFullHeight }">
      <ng-container *ngComponentOutlet="config()?.component; inputs: config()?.componentInputs"></ng-container>
    </div>
  </div>
</div>
